import { atom } from 'jotai';

import DatePickerMode from '../../types/DatePickerMode';

/**
 * This atom is only automatically written to, when the booking form is loaded.
 * But the user can however change the date picker mode during the booking process.
 */
const datePickerModeAtLoadAtom = atom<DatePickerMode>('PrimarilySingleDay');

export default datePickerModeAtLoadAtom;
